import InterestChip from "@/components/Common/InterestChip";
import {Can} from "@/permissions";
import {useCategoryStore} from "@/store/category";
import {useSettingsCompanyStore} from "@/store/company";
import {type FC} from "react";

const InterestSelection: FC = () => {
  const categories = useCategoryStore(state => state.categories);
  const maxAllowedCategories = useCategoryStore(state => state.maxAllowedCategories);
  const selectedInterests = useSettingsCompanyStore(state => state.company.interests ?? []);
  const setCompanyValue = useSettingsCompanyStore(state => state.setValue);
  const isMaxReached = selectedInterests.length === maxAllowedCategories;

  return (
    <Can I="update" a="CompanyDetails" passThrough>
      {allowed => (
        <div className="flex flex-wrap gap-x-1 gap-y-2">
          {categories.map(category => {
            const isSelected = selectedInterests.includes(category.id);

            return (
              <InterestChip
                category={category}
                className={!isSelected && isMaxReached ? "opacity-50" : undefined}
                isDisabled={!allowed || (isMaxReached && !isSelected)}
                isSelected={isSelected}
                key={category.id}
                onClick={() =>
                  setCompanyValue(
                    "interests",
                    isSelected
                      ? selectedInterests.filter(interest => interest !== category.id)
                      : [...selectedInterests, category.id],
                  )
                }
              />
            );
          })}
        </div>
      )}
    </Can>
  );
};

export default InterestSelection;
